<ng-template #content let-c="close" let-d="dismiss">
    <div class="modal-header">
        <h6 class="modal-title">{{'TITLE.TITLE_JOBS' | translate}} ({{StaffName}})</h6>
        <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body p-0">
        <div class="grdTable container-fluid mt-2">
            <div class="row grdTableHeader no-gutters">
                <div class="col-1 grdHead text-center"><i class="fas fa-arrow-up"></i></div>
                <div class="col-1 grdHead"><span translate>LBL.CALL_NO</span></div>
                <div class="col-2 grdHead"><span translate>LBL.PROPERTY_NAME</span></div>
                <div class="col-5 grdHead"><span translate>LBL.CALL_DESC</span></div>
                <div class="col-2 grdHead"><span translate>LBL.LOCATION</span></div>
            </div>
            <div class="grdBodyScroll">
                <div *ngFor="let row of Model" class="row no-gutters grdRow">
                    <div class="col-1 grdCol text-center"><i class="fas fa-arrow-up" *ngIf="row.IsEsc"></i></div>
                    <div class="col-1 grdCol"><a href="/Pages/ComplaintPrint?ComplainID={{row.ComplainId}}" target="_blank">{{row.DisplayCallNo}}</a></div>
                    <div class="col-2 grdCol">{{row.PropertyName}}</div>
                    <div class="col-5 grdCol">{{row.CallDescription}}</div>
                    <div class="col-3 grdCol">{{row.LocationName}}</div> 
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer justify-content-between">
        <div class="float-left font-weight-bold small">
            <span translate>LBL.DISCLAIMER_JOB_MISMATCH</span>
        </div>
        <div class="float-right">
             <button type="button" class="btn btn-secondary" (click)="d('close')" translate>BTN.BTN_CLOSE</button>
        </div>
</div>
</ng-template>
